import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

if (process.env.NODE_ENV !== 'production') {
  (globalThis as typeof globalThis & { __APP_QUERY_CLIENT__?: QueryClient }).__APP_QUERY_CLIENT__ = queryClient;
  if (typeof window !== 'undefined') {
    (window as typeof window & { __APP_QUERY_CLIENT__?: QueryClient }).__APP_QUERY_CLIENT__ = queryClient;
  }
}
